import graphql__72e1de6d51204667043d from "./__generated__/CityWalkWaypointRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import MapPanelsManager from "../Maps/MapPanel/MapPanelsManager";
import MapPanel from "../Maps/MapPanel/MapPanel";
import CityWalkWaypoint from "../CityWalks/CityWalkWaypoint";

const CityWalkWaypointRoute = props => {
  const { participativeModuleSlug, cityWalkWaypointId } = useParams();

  return (
    <MapPanelsManager>
      <MapPanel
        className="map-city-walk-waypoint"
        keepMapVisibleOnOpen
        id={cityWalkWaypointId}
      >
        <AppQueryRenderer
          query={CityWalkWaypointRouteQuery}
          variables={{ participativeModuleSlug, cityWalkWaypointId }}
          component={CityWalkWaypoint}
          additionalProps={props}
        />
      </MapPanel>
    </MapPanelsManager>
  );
};

const CityWalkWaypointRouteQuery = graphql__72e1de6d51204667043d;

export default CityWalkWaypointRoute;
